import { stringifyUrl } from "query-string";
export class BaseUrlFormatter {
    constructor() {
        this.format = (request, baseUrl) => {
            const url = {
                url: new URL(`${this.validateBaseUrl(baseUrl)}${this.composeEndpoint(request)}`).toString(),
                query: request.queryParams,
            };
            return stringifyUrl(url, {
                skipNull: true,
                sort: false,
                arrayFormat: "comma",
            });
        };
    }
    validateBaseUrl(baseUrl) {
        return baseUrl.endsWith("/") ? baseUrl : `${baseUrl}/`;
    }
}
//# sourceMappingURL=BaseUrlFormatter.js.map